import module from 'recursoshumanos/module.js'
import template from './template.html'

export class RecursoshumanosDirectorioContactoComponent {
  data
}

module.component('recursoshumanosDirectorioContacto', {
  controller: RecursoshumanosDirectorioContactoComponent,
  template,
  bindings: {
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/directorio/contacto/component.js